module.exports = __webpack_public_path__ + "img/img-12.850015b6.png";